export enum ParentComponentTypes {
  // Used By Witness Discrepancy Modal and Verify QOH Modal for Dynamic Text
  DispenseSummary = 'Dispense Summary',
  ClinicCharge = 'Clinic Charge',
  Unload = 'Unload',
  // Not Currently used for decision making logic - These may be reused generically in their respective workflows
  // If you choose to use these for decision logic, make sure you want all the components using them to have the same changes
  // If not create a new enum for your specific component (example: Dispense vs Dispense Summary)
  Restock = 'Restock',
  Move = 'Move',
  Dispense = 'Dispense',
  Audit = 'Audit',
  MarkClose = 'MarkClose',
  Return = 'Return',
  PurchaseOrderDetail = 'Purchase Order Detail',
  Waste = 'Waste',
  Unassign = 'Unassign',
  TransferOut = 'TransferOut',
  TransferIn = 'TransferIn',
  CancelTransfer = 'CancelTransfer',
  AnnexTransferOut = 'AnnexTransferOut',
}
